import React from 'react';
import CommitmentSheet from './CommitmentSheet';
import './CommitmentSheetOverlay.css';

/**
 * CommitmentSheetOverlay — the J4 scrim + bottom-sheet mount (#1921).
 *
 * Standard overlay pattern (`docs/design/design_standards.md` § Modal
 * Layout Pattern): click the scrim to dismiss, `stopPropagation` on the
 * sheet itself so a tap inside it never bubbles to the dismiss handler.
 * Renders nothing when `scenario` is null — callers gate on that, not on a
 * separate `isOpen` flag, so there is exactly one source of truth for
 * "which scenario is the sheet showing".
 */
function CommitmentSheetOverlay({ scenario, isStarting, onDismiss, onStart, initialModality }) {
  if (!scenario) return null;

  return (
    <div className="gd-commitment-overlay" data-testid="gd-commitment-overlay" onClick={onDismiss}>
      <div onClick={(e) => e.stopPropagation()}>
        <CommitmentSheet
          scenario={scenario}
          isStarting={isStarting}
          onDismiss={onDismiss}
          onStart={onStart}
          initialModality={initialModality}
        />
      </div>
    </div>
  );
}

export default CommitmentSheetOverlay;
